<template lang="pug">
div(v-if="guide_is_show")
  //-
    Guide for ききくる
  .map-legend(v-if="kikikuru_layer_is_show")
    //- .uk-text-bold 解析・予報 / アメダス
    //- div 今後6時間の降雪短時間予報
    div ({{ target_times.kikikuru_target_time.basetime | datetime }})
    img(:src="kikikuru_guide_url", alt="*", uk-svg)

  //-
    Guide for 6時間香水予報
  .map-legend(v-if="snowd_layer_is_show")
    .uk-text-bold 解析・予報 / アメダス
    div 今後6時間の降雪短時間予報
    div ({{ target_times.snowd_target_time.basetime | datetime }})
    img(:src="snow_guide_url", alt="*", uk-svg)

  //-
    Guide for 短時間降水予報
  .map-legend(v-if="raind_layer_is_show")
    div 今後3時間の降水短時間予報
    div ({{ target_times.raind_target_time.basetime | datetime }})
    div
      img(:src="raind_guide_url", alt="*", uk-svg)
    div
      img(:src="raind_guide_mics", alt="*", uk-svg)


  //-
    Guide for ハザードマップ
  div(v-if="!kikikuru_layer_is_show && !snowd_layer_is_show && !raind_layer_is_show")
    .uk-position-bottom-right.uk-position-small.uk-box-shadow-medium.map-guide
      .uk-section-xsmall.uk-padding-small.uk-border-rounded.uk-position-relative(v-if="guides", style="background-color: white")
        //- Title
        .uk-text-small.uk-margin-remove.uk-text-bold ハザードマップ凡例

        //-
          Guide for 浸水想定(ハザード)
        div(v-if="hazard_extends_minase_naruse_omonogawa_layer_is_show || hazard_extends_minase_naruse_omonogawa_soukihinan_layer_is_show || hazard_extends_yokotegawa_layer_is_show || hazard_extends_yokotegawa_soukihinan_layer_is_show || hazard_extends_uwamizo_layer_is_show ||  hazard_extends_saragawa_layer_is_show || hazard_extends_ootogawa_layer_is_show || hazard_extends_kashiranashigawa_layer_is_show || hazard_extends_budougawa_layer_is_show || hazard_extends_iwanomesawa_layer_is_show || hazard_extends_kuriyagawa_layer_is_show || hazard_extends_kurosawagawa_layer_is_show || hazard_extends_matsukawa_layer_is_show || hazard_extends_minasegawa_layer_is_show || hazard_extends_naraokagawa_layer_is_show || hazard_extends_narusegawa_layer_is_show || hazard_extends_sakabegawa_layer_is_show || hazard_extends_shirakogawa_layer_is_show || hazard_extends_sugisawagawa_layer_is_show || hazard_extends_ugoootogawa_layer_is_show || hazard_extends_yokotegawasannai_layer_is_show || hazard_extends_nakanomekawa_layer_is_show || hazard_extends_imokawa_layer_is_show")
          hr.uk-margin-small
          .uk-text-bold.uk-text-small 浸水想定
          div(v-for="(guide, index) in guides.flood", :key="`guide_hazard_${index}`")
            .uk-flex.uk-grid-small.uk-flex-middle
              div
                div(:style="`width: 15px; height: 15px; background-color: ${guide.color}!important`")
              div {{ guide.label }}

          div(v-if="hazard_extends_minase_naruse_omonogawa_soukihinan_layer_is_show || hazard_extends_yokotegawa_soukihinan_layer_is_show")
            .uk-flex.uk-grid-small.uk-flex-middle
              div
                div(:style="`width: 15px; height: 15px; border: dashed 2px red!important; box-sizing: border-box;`")
              div 早期避難

        div(v-if="ekijyoka_layer_is_show")
          hr.uk-margin-small
          .uk-text-bold.uk-text-small 液状化危険度
          div(v-for="(guide, index) in guides.ekijyoka", :key="`guide_ekijyoka_${index}`")
            .uk-flex.uk-grid-small.uk-flex-middle
              div
                div(:style="`width: 15px; height: 15px; background-color: ${guide.color}!important`")
              div {{ guide.label }}

        //-
          Guide for 土砂
        div(v-if="sediment_layers_is_show")
          hr.uk-margin-small
          div(v-for="(guide, index) in guides.sediment", :key="`guide_sediment_${index}`")
            .uk-flex.uk-grid-small.uk-flex-middle
              div
                div(:style="`width: 15px; height: 15px; border: solid 2px ${guide.color}!important`")
              div {{ guide.label }}

          a.uk-border-circle.uk-flex-center.uk-flex-middle.uk-position-absolute(
            href="#",
            @click.prevent="handleToggleGuide",
            style="width: 18px; height: 18px; background-color: black!important; color: white!important; display: block; border: solid 1px #2b2b2b; left: -5px; top: -5px; padding: 0; line-height: 1; text-align: center; font-size: 15px",
          ) &times;

        //-
          Guide for 溜池
        div(v-if="tameike_layers_is_show")
          hr.uk-margin-small
          .uk-flex.uk-grid-small.uk-flex-middle
            div
              div(:style="`width: 15px; height: 15px; background: rgba(0, 0, 255, 0.3); border: solid 2px blue; opacity: 0.8;`")
            div ため池浸水想定区域
          .uk-flex.uk-grid-small.uk-flex-middle
            div
              div(:style="`width: 15px; height: 15px; background: rgba(0, 0, 255, 0.3); border: solid 2px blue; opacity: 0.8; border-radius: 15px;`")
            div ため池決壊想定ポイント


</template>

<script>
import * as types from '../js/mutations/map-mutations';
import { mapGetters } from 'vuex';
import dayjs from 'dayjs';

export default {
  data: () => ({
    snow_guide_url: 'https://www.jma.go.jp/bosai/snow/images/legend_normal_snowf06h.svg',
    raind_guide_url: 'https://www.jma.go.jp/bosai/kaikotan/images/legend_jp_normal_rasrf03h.svg',
    raind_guide_mics: 'https://www.jma.go.jp/bosai/kaikotan/images/legend_jp_slmcs.svg',
    kikikuru_guide_url: 'https://www.jma.go.jp/bosai/risk/images/legend_jp_normal_land.svg',
  }),
  filters: {
    datetime: function(value) {
      const datetime = dayjs(value).add(9, 'hour');
      return datetime.format('M月D日H時時点の予想');
    },
  },
  computed: {
    ...mapGetters([
      'guides',
      'guide_is_show',
      // 'hazard_layer_is_show',
      // 'hazard_extends_layer_is_show',
      'hazard_extends_minase_naruse_omonogawa_layer_is_show',
      'hazard_extends_minase_naruse_omonogawa_soukihinan_layer_is_show',
      'hazard_extends_yokotegawa_layer_is_show',
      'hazard_extends_yokotegawa_soukihinan_layer_is_show',
      'hazard_extends_uwamizo_layer_is_show',
      'hazard_extends_saragawa_layer_is_show',
      'hazard_extends_ootogawa_layer_is_show',
      'hazard_extends_kashiranashigawa_layer_is_show',
      'hazard_extends_budougawa_layer_is_show',
      'hazard_extends_iwanomesawa_layer_is_show',
      'hazard_extends_kuriyagawa_layer_is_show',
      'hazard_extends_kurosawagawa_layer_is_show',
      'hazard_extends_matsukawa_layer_is_show',
      'hazard_extends_minasegawa_layer_is_show',
      'hazard_extends_naraokagawa_layer_is_show',
      'hazard_extends_narusegawa_layer_is_show',
      'hazard_extends_sakabegawa_layer_is_show',
      'hazard_extends_shirakogawa_layer_is_show',
      'hazard_extends_sugisawagawa_layer_is_show',
      'hazard_extends_ugoootogawa_layer_is_show',
      'hazard_extends_yokotegawasannai_layer_is_show',
      'hazard_extends_nakanomekawa_layer_is_show',
      'hazard_extends_imokawa_layer_is_show',
      'sediment_layers_is_show',
      'snowd_layer_is_show',
      'ekijyoka_layer_is_show',
      'kikikuru_layer_is_show',
      'raind_layer_is_show',
      'tameike_layers_is_show',
      'target_times',
    ]),
  },
  methods: {
    handleToggleGuide() {
      this.$store.dispatch(types.TOGGLE_GUIDE);
    },
  },
};
</script>
